import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { initMetaPixel, initUtmifyPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    initUtmifyPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}